import React from "react";
import {
  StepBtn,
  StepWrapperStyles,
} from "../../../../shared/steps/stepsStyles";
import { useTranslation } from "react-i18next";
import { ItemsWrapper } from "./styles";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { NAVBAR_ITEMS, ROUTES_IDS } from "../constants";

function Items({ items = NAVBAR_ITEMS }) {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const step = pathname.split("/").filter(Boolean).pop();

  return (
    <ItemsWrapper>
      {items?.map((item) => {
        const isActive = item.id === ROUTES_IDS[step];
        const passedStep = item > ROUTES_IDS[step];

        return (
          <StepWrapperStyles key={item.id} stepsLength={items.length}>
            <div>
              <StepBtn
                disabled={true}
                isActive={isActive}
                passedStep={passedStep}
              >
                {item.id}
              </StepBtn>
            </div>
            <div
              className={`text keepz-step-text${isActive ? " text-active" : ""}`}
              style={{ whiteSpace: "nowrap" }}
            >
              {t(item.translationKey)}
            </div>
          </StepWrapperStyles>
        );
      })}
    </ItemsWrapper>
  );
}

export default Items;
